import { addNotification } from '@redux/actions/notifications.actions';
import logger from '@utils/logger';

const errorTypes = {
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FAILED_PRECONDITION: 'FAILED_PRECONDITION',
  INVALID_ARGUMENT: 'INVALID_ARGUMENT',
  NOT_FOUND: 'NOT_FOUND',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  UNIMPLEMENTED: 'UNIMPLEMENTED',
};

const getErrorString = (errorMessage, parsePrefix) => {
  if (typeof errorMessage !== 'string') {
    return '';
  }

  if (parsePrefix) {
    const splittedMessage = errorMessage.split(':');

    if (errorTypes[splittedMessage[0]] !== undefined) {
      return splittedMessage.slice(1, splittedMessage.length).join(':').trim();
    }

    return '';
  }

  return errorMessage;
};

const requestErrorParser =
  (errorMessage: string, parsePrefix = true, requestId: string | null = null) =>
  (dispatch) => {
    const parsedErrorString = getErrorString(errorMessage, parsePrefix);
    if (parsedErrorString.trim() === '') {
      return;
    }
    let errorObj;

    try {
      errorObj = JSON.parse(parsedErrorString);
    } catch (e) {
      errorObj = {
        visible: true,
        msg: parsedErrorString,
      };
    }

    const hiddenErrors = new RegExp(/.*(exception|grpc|headers|timeout).*/g);

    if (hiddenErrors.test(errorObj.msg?.toLowerCase())) {
      // Technical errors are hidden from the user's toast, but must still be
      // visible in the console so support can trace them from screenshots.
      logger.warn('api', `notification suppressed: ${errorObj.msg}`);
      return;
    }

    if (errorObj.visible) {
      // The ref is the x-request-id of the failed call: it appears in backend
      // logs and Sentry, so a user-reported ref pinpoints the exact request.
      const title = requestId ? `${errorObj.msg} (ref: ${requestId})` : errorObj.msg;
      dispatch(addNotification({ title, type: 'error' }));
    }
  };

export default requestErrorParser;
